import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink, CONTEXT_MESSAGES, routeMessageKey } from "../lib/whatsapp";
import { track } from "../lib/analytics";

export default function WhatsAppFloat() {
  const { pathname } = useLocation();
  const key = routeMessageKey(pathname);

  return (
    <motion.a
      href={waLink(CONTEXT_MESSAGES[key])}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      onClick={() => track("whatsapp_click", { location: "floating_button", context: key, page: pathname })}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.4, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="group fixed bottom-5 right-5 z-40 flex items-center gap-3"
      aria-label="Chat on WhatsApp"
    >
      <span className="pointer-events-none hidden translate-x-2 rounded-full border border-white/10 bg-ink px-4 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-white/80 opacity-0 backdrop-blur-md transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 md:block">
        Chat on WhatsApp
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg shadow-emerald-500/25">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
        <MessageCircle className="relative h-6 w-6 text-white" fill="white" />
      </span>
    </motion.a>
  );
}
